import { post, get } from '../axios'

// 分配实验层流量
export function abLayer_allocate_post(map, option) {
  return post(
    `${process.env.VUE_APP_ABLAYER}/abLayer/allocate`,
    map,
    option
  ).then(response => response)
}

// 分页查询
export function abLayer_page_post(map, option) {
  return post(`${process.env.VUE_APP_ABLAYER}/abLayer/page`, map, option).then(
    response => response
  )
}

// 查询所有实验层
export function abLayer_queryAll_post(map, option) {
  return post(
    `${process.env.VUE_APP_ABLAYER}/abLayer/queryAll`,
    map,
    option
  ).then(response => response)
}

// 删除实验层
export function abLayer_remove_get(map, option) {
  return get(`${process.env.VUE_APP_ABLAYER}/abLayer/remove`, map, option).then(
    response => response
  )
}

// 保存实验层
export function abLayer_save_post(map, option) {
  return post(`${process.env.VUE_APP_ABLAYER}/abLayer/save`, map, option).then(
    response => response
  )
}
